export default __webpack_public_path__ + "static/media/post_views.1e4b6e25.png";